export { ComponentWithResponsive as DateRangePicker } from "./component";